import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import Upload from '../Ui/Upload';
import Loader from "react-loader-spinner";
import { toastMessage } from '../../utils/toast';
import * as jobActions from '../../Redux/Actions/jobs';
import { dateTimeFormat } from '../../utils';
import { downloadFile } from '../../utils';
import { AiOutlineDelete } from "react-icons/ai";
import { resetFileName } from '../../utils/resetFileName';

const AdditionalPaymentReferenceModal = ({ t, id, showModal, handleClose, loading, jobID, paymentReferenceInfo, handleOk}) => {

    const [attachments, setAttachments] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [attachmentId, setAttachmentId] = useState('');
    const [receiptNumber, setReceiptNumber] = useState('');

    const uploadAdditionalPaymentReference = (files) => {
        if(!files) {
            return;
        }
        
        setButtonLoading(true);
        let data = new FormData();
        data.append('jobId', jobID);
        data.append('file', resetFileName(files));
        let woExtensionName = files?.name.toLowerCase().split('.');
        if(!(['jpeg', 'jpg', 'pdf', 'png'].includes(woExtensionName[woExtensionName?.length-1]))) {
            toastMessage('error', 'Un Supported Media type!');
            setButtonLoading(false);
            return;
        } 

        setAttachments(files);
        data.append('extension', '.' + woExtensionName[woExtensionName?.length-1]);

        jobActions.uploadPaymentReceipt(data).then(res => {
            if(res && res.data){
                setAttachmentId(res.data);
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err?.message) || `Unable to upload the document`);
        });
    }

    const handleSubmit = () => {
        setButtonLoading(true);
        const payload = {
            additionalPaymentId: id,
            attachmentId: attachmentId,
            receiptNumber
        };
        handleOk(payload);
        setButtonLoading(false);
    }

    const handleDownloadDocument = (id) => {
        setButtonLoading(true);
        jobActions.downloadPaymentReceipt(id).then(res => {
            res && downloadFile(res);
            toastMessage('success', 'File downloaded successfully!');
            setButtonLoading(false);
        }).catch((err) => {
            console.log('Something Went Wrong', err);
            setButtonLoading(false);
        });
    }

    return (
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered" style={{minWidth: '700px'}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.additionalPayment.additionalPaymentReference")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            {(paymentReferenceInfo === null || paymentReferenceInfo?.status === 'Rejected')  ? 
                            <>
                                <div className="d-flex flex-column mb-3">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.receiptNumber")}</label>
                                    <input placeholder={t("jobsManagement.infoJob.additionalPayment.receiptNumberPlaceholder")} type="text" className="form-control"
                                    name="receiptNumber" value={receiptNumber} onChange={e => {setReceiptNumber(e.target.value) }} />
                                </div>
                                <div className="d-flex flex-column mb-3">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.attachments")}</label>
                                    {attachments && (attachments?.type?.includes('image') ? 
                                    <img alt="Document Preview" src={URL.createObjectURL(attachments)} style={{ width: '25%', height: 'auto', margin: '0 0 5px 0' }} />
                                    : <iframe title='PDF viewer' src={URL.createObjectURL(attachments)} style={{ width: '25%', height: 'auto', margin: '0 0 5px 0', overflow:'hidden' }}></iframe>) }
                                    <div className="d-flex align-items-center">
                                        <Upload onChange={e => uploadAdditionalPaymentReference(e.target.files[0])} />
                                        {attachmentId && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {setAttachmentId(''); setAttachments('')}} />}
                                    </div>
                                </div>
                                <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center mb-3" disabled={loading || !attachmentId} onClick={() => handleSubmit()}>{t("jobsManagement.infoJob.createReference.ok")}
                                    {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                </button>
                            </>
                            :  null }
                           { paymentReferenceInfo !== null ? <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                                <thead>
                                    <tr className="text-left">
                                        <th className="pl-7" style={{width: '50px'}}>{t("jobsManagement.infoJob.additionalPayment.sNo")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.file")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.status")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.receiptNumber")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.reason")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.approvedBy")}</th>
                                        <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.approvedDate")}</th>
                                    </tr>
                                </thead>
                                <tbody> 
                                    <tr>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{1}</span>
                                        </td>
                                        <td className="pl-7 text-center">
                                        <button className='btn btn-primary' disabled={buttonLoading} onClick={() => handleDownloadDocument(paymentReferenceInfo?.attachmentId)}>{ buttonLoading ? <Loader type="Oval" color="#fff" height={20} width={20} /> : <FiDownload className="c-pointer" />}</button>
                                        </td>
                                        <td className="text-center" style={{whiteSpace: 'nowrap'}}>
                                            <span className={"p-2 badge badge-outline-" + (paymentReferenceInfo?.status === 'Pending' ? "warning" : paymentReferenceInfo?.status === 'Approved' ? "success" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                {paymentReferenceInfo?.status}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.receiptNumber ? paymentReferenceInfo?.receiptNumber : '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.reason ? paymentReferenceInfo?.reason : '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.approvedBy ? paymentReferenceInfo?.approvedBy?.name : '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentReferenceInfo?.approvedTime ? dateTimeFormat(paymentReferenceInfo?.approvedTime) : '-'}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
}

export default AdditionalPaymentReferenceModal;